export default __webpack_public_path__ + "static/media/mic-off.d87784b9.svg";